import Icon from 'components/elements/icon';
import FeatureStore from 'apps/layout/stores/feature-store';
import InteractionForm from 'apps/interactions/components/create/interaction-form';
import { PropTypes } from 'base/react-libs';
import { useContext } from 'react';
import { useFluxStore } from '@evertrue/et-flux';
import { InteractionsContext } from '../../../profile/contexts/interactions-context';
import { PinnedCommentsContext } from '../../../profile/contexts/pinned-comments-context';
import { Modal, Button, useOpenClose } from '@evertrue/et-components';

const featureStoreMapState = () => ({
  hasInteractionWrites: FeatureStore.hasInteractionWrites(),
});

const InteractionAddBtn = ({
  interaction = {},
  contact = {},
  contactOptions = [],
  referrer,
  showIcon = false,
  buttonType = 'secondary',
  buttonClass = null,
  title,
  afterSubmit = () => {},
}) => {
  const [isOpen, open, close] = useOpenClose();
  const { hasInteractionWrites } = useFluxStore(FeatureStore, featureStoreMapState);
  const { addNewCommentToState } = useContext(PinnedCommentsContext);
  const { addNewInteractionToState } = useContext(InteractionsContext);

  let _interaction = interaction;

  if (!hasInteractionWrites) {
    delete _interaction?.interaction_type;
  }

  const afterSubmission = (newInteraction) => {
    afterSubmit(newInteraction);
    if (typeof addNewInteractionToState === 'function') {
      addNewInteractionToState(newInteraction);
    }
    if (typeof addNewCommentToState === 'function') {
      addNewCommentToState(newInteraction);
    }
  };

  const renderTitle = () => {
    if (title) return title;
    return hasInteractionWrites ? 'Add Interaction' : 'Add comment';
  };

  return (
    <>
      <Button
        title={hasInteractionWrites ? 'Add Interaction' : 'Add comment'}
        type={buttonType}
        className={buttonClass}
        onClick={open}
      >
        {showIcon && <Icon icon={'trip-log'} />}
        {renderTitle()}
      </Button>
      <Modal isOpen={isOpen} closeModal={close}>
        <InteractionForm
          contact={contact}
          contactOptions={contactOptions}
          interaction={_interaction}
          referrer={referrer}
          afterSubmit={afterSubmission}
          requestHide={close}
        />
      </Modal>
    </>
  );
};

InteractionAddBtn.propTypes = {
  interaction: PropTypes.object,
  contact: PropTypes.object,
  contactOptions: PropTypes.array,
  referrer: PropTypes.string,
  showIcon: PropTypes.bool,
  buttonType: PropTypes.string,
  buttonClass: PropTypes.string,
  title: PropTypes.string,
  afterSubmit: PropTypes.func,
};

export default InteractionAddBtn;
